export const iconFontAwesomeCommunicationVideoSlash = (
	<i className="fa-solid fa-video-slash"></i>
);
